import { Tab, Tabs } from "components/Tabs"
import useDevice from "hooks/useDevice"
import { useBeaconlistStore, useLayoutStore, useUnregisteredBeaconStore, useUserRolePermissionStore } from "contexts/RootStore.context"
import NoPermissionsPage from "views/NoPermissionsPage"
import WidthNotSupportedPage from "views/WidthNotSupportedPage"
import { useEffect, useState } from "react"
import { NewBeacons } from "./components/newBeacons/NewBeacons"
import { RegisteredBeaconList } from "./components/registeredBeacons/RegisteredBeaconList"
import { NewBeaconAssetForm } from "./components/newBeacons/NewBeaconAssetForm"
import { RefreshData } from "./components/RefreshData"
import { useNavigate, useParams } from "react-router-dom"
import { observer } from "mobx-react"
import { routePath } from "router/routePaths"

export const BeaconManagement = observer(() => {

  const { isMobileDevice } = useDevice();
  const navigate = useNavigate()
  const { canViewAssets } = useUserRolePermissionStore()
  const { loadData, reset, error, totalUnfilterBeaconsCount } = useBeaconlistStore()
  const {
    loadUnregisteredBeacons,
    totalUnfilterCount,
    selectedBeaconToCreateAsset,
    reset: reset2,
    error: unregisteredError
  } = useUnregisteredBeaconStore()
  const { setPageError } = useLayoutStore()
  const params = useParams<{ list: string }>()
  const [currentTab, setCurrentTab] = useState(params.list || "new-beacon")

  useEffect(() => {
    const abortController = new AbortController();
    if (canViewAssets && !isMobileDevice) {
      Promise.all([
        loadData(),
        loadUnregisteredBeacons()
      ])
        .finally(() => {
          if (abortController.signal.aborted) {
            reset()
            reset2()
          }
        });
    }

    return () => {
      abortController.abort();
      reset()
      reset2()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPageError(unregisteredError || error)
  }, [error, setPageError, unregisteredError])

  if (!canViewAssets) {
    return <NoPermissionsPage />
  }

  if (isMobileDevice) {
    return <WidthNotSupportedPage />;
  }

  if (selectedBeaconToCreateAsset) {
    return <NewBeaconAssetForm />
  }

  const onRefresh = () => {
    if (currentTab === "new-beacon")
      navigate(routePath.beaconManagement)
    else
      navigate(`${routePath.beaconManagement}/list`)
  }

  return (
    <Tabs
      defaultTabId={params.list ? "registered-beacons" : "new-beacon"}
      smallBorder
      scrollSelectedTab
      headerComponent={<RefreshData onRefresh={onRefresh} />}
      onTabChange={(tabId) => setCurrentTab(tabId)}
    >
      <Tab tabId="new-beacon" title={`New Beacons (${totalUnfilterCount})`}>
        <NewBeacons />
      </Tab>
      <Tab tabId="registered-beacons" title={`Registered Beacons (${totalUnfilterBeaconsCount})`}>
        <RegisteredBeaconList onRefresh={onRefresh} />
      </Tab>
    </Tabs>
  )
})